export default "__VITE_ASSET__DRvN4W22__"